import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || '';
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) { navigate('/'); return; }
        const session_id = m[1];

        (async () => {
            try {
                const res = await apiClient.post('/auth/session', { session_id });
                setUser(res.data.user);
                // strip hash, redirect by role
                const next = res.data.user.role === 'admin' ? '/admin' : '/dashboard';
                window.history.replaceState({}, document.title, window.location.pathname);
                navigate(next, { state: { user: res.data.user } });
            } catch (e) {
                console.error('Auth exchange failed', e);
                navigate('/');
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-brand-bg">
            <div className="text-center">
                <i className="fa-solid fa-anchor text-4xl text-brand-aqua mb-4 animate-pulse"></i>
                <p className="text-white/70 font-display tracking-widest uppercase text-sm">Boarding your account…</p>
            </div>
        </div>
    );
}
